export default {
  computed: {
    modalVisible: {
      get () {
        return this.$store.getters.modalVisible
      },
      set (val) {
        this.$store.commit('MODAL_VISIBLE', val)
      }
    },
    modalContent: {
      get () {
        return this.$store.getters.modalContent
      },
      set (val) {
        this.$store.commit('MODAL_CONTENT', val)
      }
    }
  },
  mounted () {
  },
  methods: {
    showInfoModal ({ title, text }) {
      this.modalContent = {
        title,
        text
      }
      this.modalVisible = true
// console.log(title, text)
    }
  },
  watch: {
    modalVisible (newVal) {
      if (newVal) {
        document.body.classList.add('modal-open')
      }
      else {
        document.body.classList.remove('modal-open')
      }
    }
  }
}
